import GLightbox from 'glightbox';
// import  'bootstrap';
import Swiper, { Navigation, Pagination,Autoplay,EffectFade } from 'swiper';


import { Tooltip,Modal } from 'bootstrap'
const tooltipTriggerList = document.querySelectorAll('[data-bs-toggle="tooltip"]')
const tooltipList = [...tooltipTriggerList].map(tooltipTriggerEl => new Tooltip(tooltipTriggerEl))
const lightbox = GLightbox({
    selector: '.StLightbox1',
    touchNavigation: true,
    loop: true,
    videosWidth: 960,
    closeOnOutsideClick: true, /// close cliked body
    autoplayVideos: true,
    svg: {

    }
  });
  const StLightbox2 = GLightbox({
    selector: '.StLightbox2',
    touchNavigation: true,
    loop: true,
    videosWidth: 960,
    closeOnOutsideClick: true, /// close cliked body
    autoplayVideos: true,
    svg: {

    }
  });
  const StLightbox3 = GLightbox({
    selector: '.StLightbox3',
    touchNavigation: true,
    loop: true,
    videosWidth: 960,
    closeOnOutsideClick: true, /// close cliked body
    autoplayVideos: true,
    svg: {

    }
  });
  // Swiper Init()
  let slider = document.getElementsByClassName('swiper-container');
if (slider.length > 0) {
  var swiper = new Swiper('.swiper-container', {
    modules: [Navigation],
    slidesPerView: 3,
    spaceBetween: 15,
    loop: true,
    autoplay: {
      delay: 2500,
      disableOnInteraction: true,
    },
    breakpoints: {
      1181: {
        slidesPerView: 3
      },
      1180: {
        slidesPerView: 3
      },
      1020: {
        slidesPerView: 2
      },
      700: {
        slidesPerView: 1
      },
      360: {
        slidesPerView: 1
      }
    },
    navigation: {
      nextEl: '.swiper-button-next',
      prevEl: '.swiper-button-prev',
    }

  });
}
// slider swiper  home init()
var swiper = new Swiper(".mySwiper", {
  modules:[Navigation, Pagination,Autoplay],
  slidesPerView: 3,
  loop:true,
   autoplay: {
    delay: 2500,
    disableOnInteraction: true,
  },
  pagination: {
    el: ".swiper-pagination",
    clickable: true,
    type: 'bullets',
  },
  navigation: {
    nextEl: ".swiper-button-next",
    prevEl: ".swiper-button-prev",
  },
  breakpoints: {
    320: {
      slidesPerView: 1,
      spaceBetween: 10,
    },
    500: {
      slidesPerView: 1,
      spaceBetween: 10,
    },
    768: {
      slidesPerView: 2,
      spaceBetween: 20,
    },
    1024: {
      slidesPerView: 3,
      spaceBetween: 20,
    },
  },
});
const homeswiper = new Swiper(".homeswiper", {
  modules:[Navigation, Pagination,EffectFade],
  spaceBetween: 30,
  effect: "fade",
  navigation: {
    nextEl: ".swiper-button-next",
    prevEl: ".swiper-button-prev",
  },
  pagination: {
    el: ".swiper-pagination",
    dynamicBullets: true,
  },
});

  // import Appsam from '../js/src/app.vue';
  // import { createApp } from "vue";
  // const app = createApp({
  //   components: {
  //     Appsam,
  //   }
  // });
  // // app.use(Steps)
  // // app.use(Modal);
  // // app.use(Tooltip)
  // app.mount("#app");
  // init Glightbox

